import type { Review } from "@/types/movie";

export const reviews: Review[] = [
  {
    id: "rv-01",
    user: "光影拾荒者",
    avatarSeed: "qx-av-01",
    rating: 9,
    date: "2024-09-02",
    content:
      "视听语言非常成熟，中段的那场戏几乎让人忘记呼吸。导演对情绪的拿捏相当克制，反而更有力量。",
  },
  {
    id: "rv-02",
    user: "夜航西飞",
    avatarSeed: "qx-av-02",
    rating: 8,
    date: "2024-08-30",
    content:
      "前半段铺陈略慢，但越到后面越有味道。演员的表演自然，配乐也很加分，值得走进影院。",
  },
  {
    id: "rv-03",
    user: "幕布之后",
    avatarSeed: "qx-av-03",
    rating: 10,
    date: "2024-08-27",
    content:
      "今年看过最惊喜的一部。美术和摄影太美了，每一帧都像画。故事虽然简单，但情感非常真诚。",
  },
  {
    id: "rv-04",
    user: "黑咖啡不加糖",
    avatarSeed: "qx-av-04",
    rating: 7,
    date: "2024-08-24",
    content:
      "类型元素的运用很到位，反转也设计得巧妙。唯一遗憾的是结尾稍显仓促，感觉还能再多展开一点。",
  },
  {
    id: "rv-05",
    user: "胶片气味",
    avatarSeed: "qx-av-05",
    rating: 9,
    date: "2024-08-20",
    content:
      "很能理解导演想表达的东西。那些没说出口的话，才是整部电影最动人的部分。看完之后久久无法平静。",
  },
  {
    id: "rv-06",
    user: "周末观影团",
    avatarSeed: "qx-av-06",
    rating: 8,
    date: "2024-08-16",
    content:
      "和家里人一起去看的，都觉得不错。节奏舒服，笑点和泪点都有，适合放松的时候看。",
  },
  {
    id: "rv-07",
    user: "银幕守夜人",
    avatarSeed: "qx-av-07",
    rating: 9,
    date: "2024-08-11",
    content:
      "细节控狂喜，二刷又发现了很多伏笔。看得出来主创团队是真的用心在讲一个故事，而不是只顾着炫技。",
  },
  {
    id: "rv-08",
    user: "橘子汽水",
    avatarSeed: "qx-av-08",
    rating: 8,
    date: "2024-08-06",
    content:
      "画面和音乐都是享受，光是这几个方面就已经值回票价了。剧本稍弱一点，但瑕不掩瑜。",
  },
];

export const watchGuides = [
  {
    id: "wg-01",
    title: "观影前须知",
    text: "本片含少量强光与骤响音效场景，对声音敏感的观众可选择影厅靠后位置观看。",
  },
  {
    id: "wg-02",
    title: "最佳观影方式",
    text: "建议选择激光厅或 IMAX 厅，能更好地还原影片在画质与声场上的设计细节。",
  },
  {
    id: "wg-03",
    title: "适合人群",
    text: "适合喜欢强剧情与氛围感的观众；片长较长，建议提前安排好时间。",
  },
  {
    id: "wg-04",
    title: "观影小贴士",
    text: "片尾有彩蛋，请耐心留到最后；观看结束后欢迎回到秋霞电影分享你的观后感。",
  },
];